<template>
    <div class="form">
        <h4 class="step-title">
            What kind of home is this?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="propertyTypes" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.propertyType"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "PropertyType",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                propertyTypes: [
                    { text: "Apartment", value: "Apartment" },
                    { text: "Condo", value: "Condominium" },
                    { text: "Duplex", value: "Duplex" },
                    { text: "Mobile Home", value: "MobileHome" },
                    { text: "Multi Family", value: "MultiFamily" },
                    { text: "Single-Family", value: "SingleFamily" },
                    { text: "Townhome", value: "Townhome" },
                    { text: "Other", value: "Other" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                this.lead.homeInsurance.propertyType = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
